module.exports = __webpack_public_path__ + "img/icon_e12.255d5e00.png";